import OrganizationsAPI from "../API/organizations.api";

const getCurrentUserOrganization = async (setter) => {
    try {
        const organization = await OrganizationsAPI.getOrganization();
        setter(organization);
        return organization;
    } catch (error) {
        console.log(error);
    }
};

export { getCurrentUserOrganization };
